<template>
  <div class="divContainerFormInputPredictiveSearch">
    <div class="divInputFormInputPredictiveSearch">
      <span class="material-icons-outlined">search</span>
      <input
        type="text"
        v-model="textSearch"
        class="inputPFormInputPredictiveSearch"
        :placeholder="placeholder"
        @input="onInput"
      />
    </div>
    <div v-show="viewOptions" class="optionsSelectFormInputPredictiveSearch">
      <div v-if="optionsFilter.length > 0">
        <div
          v-for="(option, index) in optionsFilter"
          :key="index"
          @click="selectItem(option)"
          class="itemOptionFormInputPredictiveSearch"
        >
          {{ option.text }}
        </div>
      </div>
      <div v-else>{{ textEmpty }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { SelectType } from "@/components/look/PFormSelect/pFormSelect.types";

@Component
export class PFormInputPredictiveSearch extends Vue {
  @Prop({ required: true }) propertySearch!: string;
  @Prop({ required: true }) options!: SelectType[];
  @Prop({ required: false, default: "" }) placeholder!: string;
  @Prop({ required: false, default: "Without result" }) textEmpty!: string;

  textSearch = "";

  optionsFilter: SelectType[] = [];
  viewOptions = false;
  selectItem(option: SelectType): void {
    this.textSearch = "";
    this.viewOptions = false;

    this.$emit("search", option.value);
  }

  onInput(): void {
    if (this.textSearch.length > 1) {
      this.viewOptions = true;
      this.optionsFilter = this.options.filter((op) =>
        op[this.propertySearch].toUpperCase().includes(this.textSearch.toUpperCase())
      );
    } else {
      this.viewOptions = false;
    }
  }
}
export default PFormInputPredictiveSearch;
</script>
<style scoped>
.divContainerFormInputPredictiveSearch {
  position: relative;
}
.optionsSelectFormInputPredictiveSearch {
  position: absolute;
  top: 35px;
  z-index: 5;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  border-radius: 6px;
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.12);
  border: solid 0.7px #dcdcdc;
  background-color: #fff;

  right: 24px;
  left: 24px;

  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.divInputFormInputPredictiveSearch {
  padding: 4px 10px 4px 4px;
  border-radius: 20px;
  border: solid 1px #e4e4e4;
  background-color: #fff;
  display: flex;
  align-items: center;
}
.inputPFormInputPredictiveSearch {
  width: 100%;
  border: none;
  margin-left: 5px;
}
.itemOptionFormInputPredictiveSearch {
  font-size: 0.8rem;
  padding: 5px 10px;
  cursor: pointer;
}

.itemOptionFormInputPredictiveSearch:hover {
  background-color: rgb(151, 151, 151, 0.13);
}
</style>
